/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  useMediaQuery,
  Grid,
  useTheme,
  Skeleton,
} from "@mui/material";
import { useTheme as useCustomTheme } from "../../style/theme";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import starterImg from "../../assets/startericon.png";
import privateImg from "../../assets/privateicon.png";
import businessImg from "../../assets/businessicon.png";
import enterpriseImg from "../../assets/enterpriseicon.png";
import { FaCheck } from "react-icons/fa6";
// import Divider from "@mui/material/Divider";
import axios from "axios";
import { IoIosArrowDown } from "react-icons/io";
import { useUser } from "../../hooks/Authorize";

const SubscriptionPlans = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  const platformUser = useUser();

  const [plan, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [showFixedCards, setShowFixedCards] = useState(false);
  const [organizationInfo, setOrganizationInfo] = useState();
  const [totalEmployees, settotalEmployees] = useState();
  const plansRef = useRef(null);
  const [subscriptionUser, setSubscriptionUser] = useState(null);

  const steps = ["Plan", "Add-Ons", "Pay", "Confirmation"];
  const { mode } = useCustomTheme();
  const activeStep = 0; // Dynamically set the active step (currently step 1).
  const [expandAll, setExpandAll] = useState(false); // Toggle to expand/collapse all cards
  const toggleExpandAll = () => {
    setExpandAll(!expandAll); // Toggle the state
  };
  const syncOrgIdFromUrl = () => {
    const currentPath = window.location.pathname;

    const mongooseIdRegex = /[0-9a-fA-F]{24}/;
    const match = currentPath.match(mongooseIdRegex);

    if (match) {
      const orgId = match[0];
      localStorage.setItem("orgId", orgId);
      return orgId;
    }

    return null;
  };



  useEffect(() => {
    syncOrgIdFromUrl();
  }, []); 
  const navigate = useNavigate();

  const handleChoosePlan = (plan) => {
    console.log("plan id :>> ", plan);
    navigate(`/plan-details/${plan._id}`, {
      state: { plan, organizationInfo, totalEmployees, id },
    });
  };

  const handleBackClick = () => {
    navigate("/"); // Go back to the previous page in the history stack
  };

  const getPlans = async () => {
    setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.get(`/store/plan`);
      const fetchedPlans = response.data.data;
      setPlans(fetchedPlans);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      setLoadingPlans(false); // 👈 stop loading
    }
  };

  const getOrganizationById = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.get(`/store/organization/${id}`);
      setOrganizationInfo(response?.data?.data?._doc);
      settotalEmployees(response?.data?.data?.totalEmployees);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    }
  };

  const getSubscription = async () => {
    // setLoadingPlans(true); // 👈 start loading
    try {
      const response = await axios.post(`/subscription/check-hr`, {
        orgId: id,
        userId: platformUser?._id,
      });
      const subscription = response.data.subscription;
      setSubscriptionUser(subscription);
    } catch (error) {
      console.error("Failed to fetch plans:", error);
    } finally {
      // setLoadingPlans(false); // 👈 stop loading
    }
  };

  useEffect(() => {
    getPlans();
    getOrganizationById();
    getSubscription();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!plansRef.current) return;
      const plansTop = plansRef.current.getBoundingClientRect().top;
      setShowFixedCards(plansTop <= 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  console.log("showFixedCards", showFixedCards);

  return (
    <>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            // padding: "0.5rem 1rem",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box>
        {/* Header */}
        <Typography
          variant="h6"
          sx={{
            color: mode === "light" ? "#26272C" : "#A5A5A5",
            textAlign: "center",
          }}
        >
          Subscribe to Clikkle{" "}
          <span style={{ color: "#3B84D9", fontWeight: "bold" }}>HR</span> in 4
          Easy Steps
        </Typography>
      </Box>

      {/* Steps */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          py: 3,
          px: { xs: "2rem", sm: "5rem" },
          mb: "2rem",
        }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
                mb: "-1.5rem",
                gap: "0.6rem",
                minWidth: { xs: "70px", sm: "auto" }, // prevent shrink on small
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor:
                    index === activeStep ? "#0080FF" : "transparent",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: index === activeStep ? "#fff" : "#A5A5A5",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                {index + 1}
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: index === activeStep ? "black" : "#A5A5A5",
                  fontSize: { xs: "0.75rem", sm: "0.9rem" },
                  width: { xs: "60px", sm: "auto" }, // wrap long text nicely
                }}
              >
                {step}
              </Typography>
            </Box>

            {index < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  backgroundColor: "#A5A5A5",
                  mx: { xs: "auto", sm: "10px" }, // margin X
                  my: { xs: "0.7rem", sm: 0 }, // margin Y
                  width: { xs: "60%", sm: "100%" },
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>

      <Grid container spacing={2} sx={{ p: 2 }}>
        {loadingPlans ? (
          Array.from(new Array(4)).map((_, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Card
                sx={{
                  height: 350,
                  borderRadius: 3,
                  padding: 2,
                  background: mode === "light" ? "#fff" : "#121212",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  height={40}
                  width="30%"
                  sx={{ mb: 2 }}
                />
                <Skeleton variant="text" height={30} width="60%" />
                <Skeleton
                  variant="text"
                  height={20}
                  width="80%"
                  sx={{ mb: 2 }}
                />
                <Skeleton variant="rectangular" height={100} sx={{ mb: 2 }} />
                <Skeleton variant="rounded" height={40} />
              </Card>
            </Grid>
          ))
        ) : plan?.length > 0 ? (
          plan?.map((plan) => {
            const isPopular = plan.name === "Enterprise";
            const features = plan?.permission;

            return (
              <Grid item xs={12} sm={6} md={3} key={plan._id}>
                <Card
                  sx={{
                    height: expandAll ? "100%" : 350,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    background: isPopular
                      ? "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)"
                      : mode === "light"
                      ? "#ffff"
                      : "#121212",
                    color: "#fff",
                    borderRadius: 3,
                    border: isPopular ? "none" : "1px solid #0080FF",
                    position: "relative",
                    paddingY: isMobile ? 2 : 4,
                    paddingX: isMobile ? 2 : 1,
                    transition: "height 0.3s ease",
                  }}
                >
                  {isPopular && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background: "#3ea2fb",
                        color: "#fff",
                        fontSize: isMobile ? "0.4rem" : "0.7rem",
                        fontWeight: "bold",
                        px: isMobile ? 0.5 : 1.5,
                        py: isMobile ? 0.1 : 0.5,
                        borderRadius: "4px",
                      }}
                    >
                      Popular
                    </Box>
                  )}

                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                    }}
                  >
                    {/* Header */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: isMobile ? 50 : 48,
                          height: isMobile ? 50 : 48,
                          borderRadius: 2,
                          backgroundColor: isPopular
                            ? "#fff"
                            : mode === "light"
                            ? "#f3f3f3"
                            : "#242424",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            plan?.name === "Starter"
                              ? starterImg
                              : plan?.name === "Private"
                              ? privateImg
                              : plan?.name === "Business"
                              ? businessImg
                              : enterpriseImg
                          }
                          alt="icon"
                          width="30"
                          height="30"
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "1rem" : "0.9rem",
                            fontWeight: 400,
                            color: isPopular
                              ? "#D9DBE9"
                              : mode === "light"
                              ? "#26272C"
                              : "#fff",
                          }}
                        >
                          {plan.title}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: isMobile ? "1.2rem" : "1.25rem",
                            fontWeight: "bold",
                            color: isPopular
                              ? "#fff"
                              : mode === "light"
                              ? "#26272C"
                              : "#D9DBE9",
                          }}
                        >
                          {plan.name}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Description */}
                    <Typography
                      sx={{
                        fontSize: isMobile ? "1rem" : "0.87rem",
                        mb: 2,
                        color: isPopular
                          ? "#D9DBE9"
                          : mode === "light"
                          ? "#585A5A"
                          : "#D9DBE9",
                        height: isMobile ? "80px" : "85px",
                        overflow: "visible",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {plan.description}
                    </Typography>

                    {/* Price */}
                    <Box>
                      <Typography
                        sx={{
                          fontSize: isMobile ? "1.9rem" : "2.2rem",
                          fontWeight: 700,
                          color: isPopular ? "#fff" : "#0080FF",
                          mb: 2,
                        }}
                      >
                        {plan.amount === "0" ? "Free" : plan.amount / 12}
                        {plan.amount !== "0" && (
                          <>
                            <span
                              style={{
                                fontSize: isMobile ? "0.7rem" : "0.9rem",
                                fontWeight: 400,
                                color: isPopular
                                  ? "#D9DBE9"
                                  : mode === "light"
                                  ? "#585A5A"
                                  : "#D9DBE9",
                                marginLeft: 4,
                              }}
                            >
                              /monthly
                            </span>
                          </>
                        )}
                      </Typography>
                    </Box>

                    {/* Features */}
                    {expandAll && (
                      <Box
                        sx={{
                          pr: 1,
                          height: "90%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "start",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: isMobile ? "0.8rem" : "0.9rem",
                            mb: 1,
                            color: isPopular
                              ? "#fff"
                              : mode === "light"
                              ? "#26272C"
                              : "#fff",
                          }}
                        >
                          What’s included
                        </Typography>

                        {features.map((feature, index) => {
                          console.log("feature==>", feature);

                          return (
                            <Box
                              key={index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              {feature.isPermission ? (
                                <CheckCircleIcon
                                  sx={{
                                    fontSize: isMobile ? 16 : 18,
                                    color: isPopular ? "#ffff" : "#0080FF",
                                    mr: 1,
                                  }}
                                />
                              ) : (
                                <CancelIcon
                                  sx={{
                                    fontSize: isMobile ? 16 : 18,
                                    color: isPopular ? "#ffff" : "#0080FF",
                                    mr: 1,
                                  }}
                                />
                              )}
                              <Typography
                                sx={{
                                  fontSize: isMobile ? "0.75rem" : "0.85rem",
                                  color: isPopular
                                    ? "#D9DBE9"
                                    : mode === "light"
                                    ? "#26272C"
                                    : "#D9DBE9",
                                }}
                              >
                                {feature.content}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "0%",
                        mt: 2,
                        mb: 1,
                      }}
                    >
                      <Button
                        onClick={() => handleChoosePlan(plan)}
                        fullWidth
                        variant="contained"
                        disabled={
                          plan?.name === subscriptionUser?.planName &&
                          subscriptionUser?.subscription
                        }
                        sx={{
                          background: isPopular
                            ? "#fff"
                            : "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)",
                          color: isPopular ? "#2563EB" : "#fff",
                          fontSize: isMobile ? "0.9rem" : "0.875rem",
                          fontWeight: 600,
                          textTransform: "none",
                          "&:hover": {
                            background: isPopular
                              ? "#e2e8f0"
                              : "linear-gradient(42deg, rgba(67,183,230,0.9) 13%, rgba(0,128,255,0.9) 40%)",
                          },
                          mb: plan?.name === "Enterprise" ? "2px" : "",
                          padding: isMobile ? "15px 0px" : "10px 0px",
                        }}
                      >
                        {plan?.name === subscriptionUser?.planName &&
                        subscriptionUser?.subscription
                          ? "Upgrade your plan"
                          : "Choose Plan"}
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
        ) : (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="300px"
            gridColumn="1 / -1"
          >
            <Typography variant="h5" sx={{ color: "#A5A5A5" }}>
              No plans found for Clikkle HR
            </Typography>
          </Box>
        )}
      </Grid>

      {/*fixed card */}
      {showFixedCards && expandAll && plan?.length > 0 && (
        <Box
          mt={4}
          sx={{
            position: "fixed",
            top: -35,
            width: "100%",
            overflowX: "auto",
            pr: isMobile ? "24px" : "21px",
            pl: isMobile ? "16px" : "16px",
            zIndex: 1300,
            // backgroundColor:'red'
          }}
        >
          <Box
            sx={{
              // border: "1px solid #0080FF", // deep blue like image
              // borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <table
              // ref={plansRef}
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                border: "1px solid #0080FF",
                // position: "fixed",
                // top: 0,
                // left: 0,
                // right: 0,
                // zIndex: 1300,
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: mode === "light" ? "#f9f9f9" : "#121212",
                  }}
                >
                  <th
                    style={{
                      textAlign: "center",
                      padding: "14px 16px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#60A5FA",
                      width: "30%",
                      borderRight: "1px solid #0080FF",
                      display: isMobile ? "none" : "",
                    }}
                  >
                    <Button
                      sx={{
                        border: "1px solid #0080FF",
                        borderRadius: 6,
                        px: 5,
                      }}
                    >
                      All Features
                    </Button>
                  </th>
                  {plan.map((item, idx) => {
                    const isPopular = item.name === "Enterprise";
                    return (
                      <th
                        key={item.id}
                        style={{
                          textAlign: "center",
                          padding: isMobile ? "2px 3px" : "14px 8px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#60A5FA",
                          width: isMobile ? "60px" : `${70 / plan.length}%`, // 👈 fixed width on mobile
                          borderRight:
                            idx === plan.length - 1
                              ? "none"
                              : "1px solid #0080FF",
                        }}
                      >
                        <Card
                          key={item.id}
                          sx={{
                            width: "100%",
                            flexShrink: 0,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            background: isPopular
                              ? "linear-gradient(180deg, #1DA1F2 0%, #2563EB 100%)"
                              : mode === "light"
                              ? "#ffff"
                              : "#121212",
                            boxShadow: "none",
                            color: "#fff",
                            borderRadius: 3,
                            // border: isPopular ? "none" : "1px solid #0080FF",
                            position: "relative",
                            p: isMobile ? 1 : 3,
                            transition: "height 0.3s ease",
                          }}
                        >
                          {isPopular && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "#3ea2fb",
                                color: "#fff",
                                fontSize: isMobile ? "0.4rem" : "0.7rem",
                                fontWeight: "bold",
                                px: isMobile ? 0.5 : 1.5,
                                py: isMobile ? 0.1 : 0.5,
                                borderRadius: "4px",
                              }}
                            >
                              Popular
                            </Box>
                          )}

                          <CardContent sx={{ height: "100%" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",

                                flexDirection: isMobile ? "column" : "",
                                gap: isMobile ? 0 : 2,
                                mb: isMobile ? 0 : 2,
                              }}
                            >
                              <Box
                                sx={{
                                  width: isMobile ? 32 : 65,
                                  height: isMobile ? 32 : 55,
                                  borderRadius: 2,
                                  backgroundColor:
                                    mode === "light" ? "#f3f3f3" : "#1e1e1e",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={
                                    item?.name === "Starter"
                                      ? starterImg
                                      : item?.name === "Private"
                                      ? privateImg
                                      : item?.name === "Business"
                                      ? businessImg
                                      : enterpriseImg
                                  }
                                  alt="icon"
                                  width={isMobile ? "20" : "30"}
                                  height={isMobile ? "20" : "30"}
                                />
                              </Box>
                              <Box>
                                <Typography
                                  sx={{
                                    fontSize: isMobile ? "0.7rem" : "0.6rem",
                                    fontWeight: 400,
                                    color:
                                      mode === "light" ? "#585A5A" : "#cfcfcf",
                                    textAlign: isMobile ? "center" : "left",
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontSize: isMobile ? "0.6rem" : "0.9rem",
                                    fontWeight: "bold",
                                    color:
                                      mode === "light" ? "#26272C" : "#fff",
                                  }}
                                >
                                  {item.name}
                                </Typography>
                              </Box>
                            </Box>

                            <Typography
                              sx={{
                                fontSize: isMobile ? "0.8rem" : "1.6rem",
                                fontWeight: "bold",
                                color: isPopular ? "#fff" : "#38bdf8",
                                mb: isMobile ? 0 : 2,
                              }}
                            >
                              {item.amount === "0" ? "Free" : item.amount / 12}
                              {item.amount !== "0" && (
                                <span
                                  style={{
                                    fontSize: isMobile ? "0.5rem" : "0.7rem",
                                    marginLeft: 4,
                                  }}
                                >
                                  /monthly
                                </span>
                              )}
                            </Typography>
                          </CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "0%",
                              mb: 1,
                            }}
                          >
                            <Button
                              onClick={() => handleChoosePlan(item)}
                              fullWidth
                              variant="contained"
                              disabled={
                                item?.name === subscriptionUser?.planName &&
                                subscriptionUser?.subscription
                              }
                              sx={{
                                background: isPopular
                                  ? "#fff"
                                  : "linear-gradient(42deg, rgba(67,183,230,1) 13%, rgba(0,128,255,1) 40%)",
                                color: isPopular ? "#2563EB" : "#fff",
                                fontSize: isMobile ? "0.4rem" : "0.775rem",
                                fontWeight: 600,
                                textTransform: "none",
                                "&:hover": {
                                  background: isPopular
                                    ? "#e2e8f0"
                                    : "linear-gradient(42deg, rgba(67,183,230,0.9) 13%, rgba(0,128,255,0.9) 40%)",
                                },
                              }}
                            >
                              {item?.name === subscriptionUser?.planName &&
                              subscriptionUser?.subscription
                                ? "Selected"
                                : "Choose Plan"}
                            </Button>
                          </Box>
                        </Card>
                      </th>
                    );
                  })}
                </tr>
              </thead>
            </table>
          </Box>
        </Box>
      )}

      {isMobile
        ? expandAll && plan?.length > 0 && (
            <Box mt={4} sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      border: "1px solid #0080FF",
                      borderRadius: "12px",
                      padding: 2,
                      backgroundColor: mode === "light" ? "#fff" : "#1e1e1e",
                    }}
                  >
                    <Typography
                      sx={{
                        flex: 1,
                        fontSize: "25px",
                        fontWeight: 700,
                        color: mode === "light" ? "#111" : "#f3f4f6",
                        padding: "12px 8px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Functionality
                    </Typography>

                    {/* Plans Title Row */}
                    <Box
                      sx={{
                        display: "flex",
                        borderBottom: "1px solid #0080FF",
                      }}
                    >
                      {plan.map((item, idx) => (
                        <Typography
                          key={item.id}
                          sx={{
                            textAlign: "start",
                            padding: "0px 4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: mode === "light" ? "#111" : "#FFFFFF",
                            borderRight:
                              idx === plan.length - 1
                                ? "none"
                                : "1px solid #0080FF",
                            flex: 1,
                          }}
                        >
                          {item.name}
                        </Typography>
                      ))}
                    </Box>

                    {/* Feature Comparison Rows */}
                    {Array.from(
                      new Set(
                        plan.flatMap((p) => p.permission.map((f) => f.content))
                      )
                    ).map((featureName, index) => {
                      console.log("featureName", featureName);
                      return (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            borderBottom: "1px solid #0080FF",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          {/* Feature Name Column */}
                          <Typography
                            sx={{
                              flex: 1,
                              fontSize: "14px",
                              fontWeight: 600,
                              color: mode === "light" ? "#26272C" : "#FFFFFF",
                              padding: "12px 8px",
                              textAlign: "start",
                              width: "100%",
                            }}
                          >
                            {featureName}
                          </Typography>

                          {/* Feature Value Columns */}
                          <Box
                            sx={{
                              display: "flex",
                              borderTop: "1px solid #0080FF",
                              borderBottom: "1px solid #0080FF",
                              width: "100%",
                            }}
                          >
                            {plan.map((item, idx) => {
                              const feature = item.permission.find(
                                (f) => f.content === featureName
                              );
                              const value = feature?.isPermission;

                              return (
                                <Typography
                                  key={item.id + featureName}
                                  sx={{
                                    textAlign: "center",
                                    padding: isMobile ? "6px 4px" : "12px 8px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#FFFFF",
                                    whiteSpace: "pre-line",
                                    borderRight:
                                      idx === plan.length - 1
                                        ? "none"
                                        : "1px solid #0080FF",
                                    flex: 1, // make them equal width
                                  }}
                                >
                                  {value === true ? (
                                    <FaCheck style={{ color: "#0080FF" }} />
                                  ) : typeof value === "string" ||
                                    typeof value === "number" ? (
                                    value
                                  ) : (
                                    "–"
                                  )}
                                </Typography>
                              );
                            })}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )
        : expandAll && plan?.length > 0 && (
            <Box mt={4} sx={{ overflowX: "auto", p: 2 }}>
              <Box
                sx={{
                  border: "1px solid #0080FF", // deep blue like image
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <table
                  ref={plansRef}
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor:
                          mode === "light" ? "#f9f9f9" : "#1e1e1e",
                      }}
                    >
                      <th
                        style={{
                          textAlign: "center",
                          padding: "14px 16px",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: mode === "light" ? "#26272C" : "#FFFFFF",
                          width: "30%",
                          borderRight: "1px solid #0080FF",
                          borderBottom: "1px solid #0080FF",
                        }}
                      >
                        Functionality
                      </th>
                      {plan.map((item, idx) => (
                        <th
                          key={item.id}
                          style={{
                            textAlign: "center",
                            padding: "14px 8px",
                            fontWeight: 600,
                            fontSize: "14px",
                            color: mode === "light" ? "#26272C" : "#FFFFFF",
                            width: `${70 / plan.length}%`,
                            borderRight:
                              idx === plan.length - 1
                                ? "none"
                                : "1px solid #0080FF",
                            borderBottom:
                              idx === plan.length
                                ? "none"
                                : "1px solid #0080FF",
                          }}
                        >
                          {item.name}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from(
                      new Set(
                        plan.flatMap((item) =>
                          item.permission.map((f) => f.content)
                        )
                      )
                    ).map((featureName, i) => (
                      <tr
                        key={featureName}
                        style={{
                          backgroundColor:
                            mode === "light" ? "#f6f8fa" : "transparent",
                        }}
                      >
                        <td
                          style={{
                            textAlign: "left",
                            padding: "12px 16px",
                            fontSize: "14px",
                            color: mode === "light" ? "#111" : "#d1d5db",
                            // borderTop: "1px solid #0080FF",
                            borderRight: "1px solid #0080FF",
                          }}
                        >
                          {featureName}
                        </td>
                        {plan.map((item, idx) => {
                          const feature = item.permission.find(
                            (f) => f.content === featureName
                          );
                          const value = feature?.isPermission;
                          return (
                            <td
                              key={item.id + featureName}
                              style={{
                                textAlign: "center",
                                padding: isMobile ? "6px 4px :" : "12px 8px",
                                fontSize: "14px",
                                color: mode === "light" ? "#111" : "#f3f4f6",
                                // borderTop: "1px solid #0080FF",
                                borderRight:
                                  idx === plan.length - 1
                                    ? "none"
                                    : "1px solid #0080FF",
                              }}
                            >
                              {value === true ? (
                                <FaCheck style={{ color: "#0080FF" }} />
                              ) : typeof value === "string" ||
                                typeof value === "number" ? (
                                value
                              ) : (
                                "–"
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          )}

      <Box
        sx={{ pt: 2, px: 2, pb: isMobile ? 2 : 0 }}
        onClick={toggleExpandAll}
      >
        {/* Expand Button */}
        <Button sx={{ color: "#A5A5A5" }} onClick={toggleExpandAll}>
          {expandAll ? "Hide features & Add-ons" : "Show features & Add-ons"}
          <IoIosArrowDown style={{ paddingLeft: 5 }} />
        </Button>
      </Box>
    </>
  );
};

export default SubscriptionPlans;
